type Client = {
  name: string;
  logo: string;
};

export const clients: Client[] = [
  {
    name: "Lojas Elder",
    logo: "/landing-page/partners/lojas-elder-cliente-fidexa.png",
  },
  {
    name: "Tangará",
    logo: "/landing-page/partners/tangara-cliente-fidexa.png",
  },
  {
    name: "Dantom Multimarcas",
    logo: "/landing-page/partners/dantom-multimarcas-cliente-fidexa.png",
  },
  {
    name: "Grupo Minas",
    logo: "/landing-page/partners/grupo-minas-cliente-fidexa.png",
  },
  {
    name: "Lojas Rosário",
    logo: "/landing-page/partners/lojas-rosario-cliente-fidexa.png",
  },
  {
    name: "Sakal Moda",
    logo: "/landing-page/partners/sakal-moda-cliente-fidexa.png",
  },
  {
    name: "Sapataria Avenida",
    logo: "/landing-page/partners/sapataria-avenida-cliente-fidexa.png",
  },
  {
    name: "Sete 4 Sete",
    logo: "/landing-page/partners/sete-4-sete-cliente-fidexa.png",
  },
  {
    name: "Omara Calçados",
    logo: "/landing-page/partners/omara-calcados-cliente-fidexa.png",
  },
  {
    name: "SuperModas",
    logo: "/landing-page/partners/supermodas-cliente-fidexa.png",
  },
  {
    name: "Lojas Skala",
    logo: "/landing-page/partners/lojas-skala-cliente-fidexa.png",
  }
];
